import { ReactNode, FC } from 'react';
import { Text } from '@dodilio/ui-design-lib';
import { HeroShell } from '../../components/HeroShell';

interface CreateOrgLayoutProps {
    children: ReactNode;
}

const CreateOrgPane = () => (
    <>

        <h1
            style={{
                fontSize: 'clamp(22px, 2.6vw, 28px)',
                fontWeight: 500,
                lineHeight: 1.06,
                letterSpacing: '-0.03em',
                margin: '0 0 18px',
                color: 'var(--gray-12)',
            }}
        >
            Name your{' '}
            <span
                style={{
                    color: 'var(--gray-11)',
                    fontWeight: 300,
                    fontSize: '0.78em',
                }}
            >
                workspace.
            </span>
        </h1>

        <Text
            as="p"
            size="2"
            className="heroPaneDesc"
            style={{ color: 'var(--gray-11)', margin: '0 0 22px', lineHeight: 1.5 }}
        >
            This name appears across Dodil services and in your API endpoints.
        </Text>
    </>
);

export const CreateOrgLayout: FC<CreateOrgLayoutProps> = ({ children }) => {
    return (
        <HeroShell title="Create your organization" leftPane={<CreateOrgPane />}>
            {children}
        </HeroShell>
    );
};
